import { loggedInUserHasRole } from '../lib'

export const hasCharityEditPermission = () => loggedInUserHasRole('MYTOMRA_CHARITIES_WRITE')
export const hasMytomraBackofficePermission = () => loggedInUserHasRole('MYTOMRA_BACKOFFICE_READ')
export const hasViewUnclaimedBagsPermission = () => loggedInUserHasRole('MYTOMRA_MANAGER_BAGS')
export const hasViewCharitiesPermission = () => loggedInUserHasRole('MYTOMRA_CHARITIES_READ')
export const hasExternalLocationWritePermission = () => loggedInUserHasRole('MYTOMRA_EXTERNAL_LOCATION_WRITE')
export const hasNotesWritePermission = () => loggedInUserHasRole('MYTOMRA_MANAGER_NOTES_WRITE')
export const hasEditUserPermission = () => loggedInUserHasRole('MYTOMRA_MANAGER_WRITE')
